module.exports = __webpack_public_path__ + "img/emoji_23.77bb7356.png";